import {
  ClickOutlined,
  CloseOutlined,
  LinkCircleOutlined,
  WarningOutlined,
} from '@easyv/react-icons';
import { ReactNode } from 'react';
import { InfoList } from '@/store';
import { isNil, jumpToModelOptimizerPage } from '@/utils';
import * as React from 'react';
import { ProModal } from './ProModal';
import { importModelHelpLink } from './utils';

interface ImportModelInfoModalProps {
  fileCount: number;
  data: InfoList;
  open: boolean;
  onConfirmUpload: (alsoUploadWarning: boolean) => void;
  onClose: () => void;
}

export function ImportModelInfoModal(props: ImportModelInfoModalProps) {
  const { fileCount, data, open, onClose, onConfirmUpload } = props;
  const { errorList, formatList, sizeLimitList, warningList } = data;
  const errorInfoCount = errorList.length + formatList.length + sizeLimitList.length;

  const getRenderModalInfo: () => {
    title: ReactNode;
    okText: ReactNode;
    cancelText: ReactNode;
    onOk: () => void;
    onCancel: () => void;
  } = () => {
    if (fileCount === 1) {
      if (warningList.length > 0) {
        return {
          title: '存在参数错误',
          cancelText: '取消',
          okText: '导入',
          onOk: () => {
            onConfirmUpload(true);
          },
          onCancel: () => {
            onClose();
          },
        };
      } else {
        return {
          title: '导入信息',
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            onClose();
          },
          onCancel: () => {
            onClose();
          },
        };
      }
    } else {
      const Title = (
        <div className='text-white flex'>
          <div>导入信息</div>
          <div
            className='cursor-pointer text-primary text-xs pl-2 flex items-center hover:text-white'
            onClick={() => {
              window.open(importModelHelpLink, '_blank', 'noreferrer');
            }}
          >
            <LinkCircleOutlined className='anticon' />
            <div>帮助文档</div>
          </div>
        </div>
      );
      if (warningList.length > 0) {
        return {
          title: Title,
          cancelText: '取消',
          okText: '保留参数错误模型导入',
          onOk: () => {
            onConfirmUpload(true);
          },
          onCancel: () => {
            onConfirmUpload(false);
          },
        };
      } else {
        return {
          title: Title,
          cancelText: null,
          okText: '确认',
          onOk: () => {
            onConfirmUpload(false); // 只有错误模型时，确认是只导入正常模型
          },
          onCancel: () => {
            onClose();
          },
        };
      }
    }
  };
  const a = getRenderModalInfo();
  return (
    <ProModal
      className='import-model-modal'
      style={{ maxHeight: 'calc(100% - 240px)', width: '480px', overflowY: 'hidden' }}
      visible={open}
      title={
        <div className='flex items-center text-base align-middle h-10 text-white justify-between'>
          <div>{a.title}</div>
          <CloseOutlined
            className='anticon text-content3 text-lg flex justify-center cursor-pointer hover:text-white'
            onClick={onClose}
          />
        </div>
      }
      closable={false}
      cancelText={a.cancelText}
      hideCancel={isNil(a.cancelText)}
      okText={a.okText}
      onOk={a.onOk}
      onCancel={a.onCancel}
    >
      <div
        className='overflow-y-auto'
        style={{ maxHeight: 'calc(100vh - 240px - 52px - 48px - 32px)' }}
      >
        {errorInfoCount > 0 && (
          <div className='my-2 text-content3'>{`${errorInfoCount}个模型无法导入`}</div>
        )}
        {sizeLimitList.length > 0 ? (
          <div className='flex flex-col gap-y-3'>
            <div className='text-exception bg-[#E6645F1A] text-xs h-7 flex justify-start items-center rounded'>
              <WarningOutlined size={16} className='px-2' />
              <div>文件大小超出限制</div>
            </div>
            <div className='h-16 overflow-scroll no-scroll-container bg-black text-baseText px-3 py-2 rounded-sm border border-borderColorMain'>
              {data.sizeLimitList.map((a, index) => {
                return (
                  <div key={index}>
                    <span className='text-baseText'> {a.fileName}</span>
                    <span className='text-content4 ml-2'>
                      {a.time.format('YYYY.MM.DD HH:mm:ss')}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {formatList.length > 0 ? (
          <div className='flex flex-col gap-y-3'>
            <div className='text-exception bg-[#E6645F1A] text-xs h-7 flex justify-start items-center rounded'>
              <WarningOutlined size={16} className='px-2' />
              <div>格式不正确</div>
            </div>
            <div className='h-16 overflow-scroll no-scroll-container bg-black text-baseText px-3 py-2 rounded-sm border border-borderColorMain'>
              {data.formatList.map((a, index) => {
                return (
                  <div key={index}>
                    <span className='text-baseText'> {a.fileName}</span>
                    <span className='text-content4 ml-2'>
                      {a.time.format('YYYY.MM.DD HH:mm:ss')}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {errorList.length > 0 ? (
          <div className='flex flex-col gap-y-2'>
            <div className='text-exception bg-[#E6645F1A] text-xs h-7 flex justify-start items-center rounded'>
              <WarningOutlined size={16} className='px-2' />
              <div>存在错误，无法导入场景使用</div>
            </div>
            <div className='grid gap-y-2'>
              {data.errorList.map((a, index) => {
                return (
                  <div
                    key={index}
                    className='max-h-32 overflow-scroll no-scroll-container bg-bg292930 text-baseText px-3 py-2 rounded-md border border-borderColorMain'
                  >
                    <div className='h-5 flex items-center justify-between'>
                      <div className='overflow-middle-wrap bg-bg292930'>
                        <div className='overflow-middle-text'>{a.fileName}</div>
                        <div className='overflow-middle-title' title={a.fileName}>
                          {a.fileName}
                        </div>
                      </div>

                      {a.desc.find((b) => b.canOptimize) &&
                        !(window as any).__EASYTWIN_CONFIGS__.local && (
                          <span
                            className='text-primary inline-flex items-center gap-x-[2px] ms-2 cursor-pointer flex-shrink-0'
                            onClick={() => {
                              jumpToModelOptimizerPage(a.fileName, a.file);
                            }}
                          >
                            <ClickOutlined />
                            <span>去优化</span>
                          </span>
                        )}
                    </div>
                    {a.desc.map((b, index) => (
                      <div key={index} className='text-content3'>
                        {b.message}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {warningList.length > 0 ? (
          <div className='flex flex-col gap-y-2'>
            <div className='text-content3'>{`${warningList.length}个存在参数错误：`}</div>
            <div className='text-warning bg-[#F59E4126] text-xs h-7 flex justify-start items-center rounded'>
              <WarningOutlined size={16} className='px-2' />
              <div>存在参数错误，可忽略警告继续使用，建议修复后导入</div>
            </div>
            <div className='grid gap-y-2'>
              {data.warningList.map((a, index) => {
                return (
                  <div
                    key={index}
                    className='max-h-32 overflow-scroll no-scroll-container bg-bg292930 text-baseText px-3 py-2 rounded-md border border-borderColorMain'
                  >
                    <div className='h-5 flex items-center'>
                      <span className='text-baseText'> {a.fileName}</span>
                      {a.desc.find((b) => b.canOptimize) &&
                        !(window as any).__EASYTWIN_CONFIGS__.local && (
                          <span
                            className='text-primary inline-flex items-center gap-x-[2px] ms-2 cursor-pointer'
                            onClick={() => {
                              jumpToModelOptimizerPage(a.fileName, a.file);
                            }}
                          >
                            <ClickOutlined />
                            <span>去优化</span>
                          </span>
                        )}
                    </div>
                    {a.desc.map((b, index) => (
                      <div key={index} className='text-content3'>
                        {b.message}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </ProModal>
  );
}
